import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Homepage />} />
          {/*<Route path='home' element={<Homepage />} />*/}
          {/*<Route path='home2' element={<HomePage2 />} />*/}
          {/*<Route path='about' element={<AboutPage />} />*/}
          {/*<Route path='appoinment' element={<AppoinmentPage />} />*/}
          {/*<Route path='department' element={<Department />} />*/}
          {/*<Route path='department-single/:slug' element={<DepertmentSinglePage />} />*/}
          {/*<Route path='services' element={<ServicePage />} />*/}
          {/*<Route path='service-single/:slug' element={<SeviceSinglePage />} />*/}
          {/*<Route path='team' element={<TeamPage />} />*/}
          {/*<Route path='team-single/:slug' element={<TeamSinglePage />} />*/}
          {/*<Route path='blog' element={<BlogPage />} />*/}
          {/*<Route path='blog-left-sidebar' element={<BlogPageLeft />} />*/}
          {/*<Route path='blog-fullwidth' element={<BlogPageFullwidth />} />*/}
          {/*<Route path='blog-single/:slug' element={<BlogDetails />} />*/}
          {/*<Route path='blog-single-left-sidebar/:slug' element={<BlogDetailsLeftSiide />} />*/}
          {/*<Route path='blog-single-fullwidth/:slug' element={<BlogDetailsFull />} />*/}
          {/*<Route path='contact' element={<ContactPage />} />*/}
          {/*<Route path='/404' element={<ErrorPage />} />*/}
          {/*<Route path='/shop' element={<ShopPage />} />*/}
          {/*<Route path='/product-single/:slug' element={<ProductSinglePage />} />*/}
          {/*<Route path='/cart' element={<CartPage />} />*/}
          {/*<Route path='/wishlist' element={<WishlistPage />} />*/}
          {/*<Route path='/checkout' element={<CheckoutPage />} />*/}
          {/*<Route path='/order_received' element={<OrderRecived />} />*/}
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
